module.exports = {"pagination":{"ListItems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/mediastore-data-2017-09-01.paginators.json
// module id = 1304
// module chunks = 0